import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { UserRegisterRequestBody, UserRegisterResponse } from "./types";

export class UserRegisterAPI extends BaseAPI<
  UserRegisterRequestBody,
  UserRegisterResponse
> {
  protected route = ApiRoutes.auth.register;
  protected method = RequestMethod.POST;
}
